module.exports = __webpack_public_path__ + "static/media/truba-no-corrosion.e7116717.jpg";